import { Unifree } from '@yes.technology/react-toolkit'
import type { DataFieldUnifreeProps } from './DataFieldUnifree.types'

const DataFieldUnifree = ({
  commonProps,
  inputRef,
  value,
  onChangeValues,
  isValid
}: DataFieldUnifreeProps) => {
  const statusClass = isValid ? ('valid' as const) : ('default' as const)

  return (
    <Unifree
      {...commonProps}
      ref={inputRef}
      value={value}
      onChange={onChangeValues}
      statusClass={statusClass}
    />
  )
}

export default DataFieldUnifree
